import React from 'react';
import AppFeature from './root';
import { AuthFeature } from './features';
import { Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { ACCESS_TOKEN_KEY } from './core/config';
import { LoadingStatus } from './core/enums';
import { ArcGlobalLoading } from './core/widgets';
import { routesConfig } from './core/routes';

const Main: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [initialized, setInitialized] = React.useState(LoadingStatus.NEVER);

  const initApp = () => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    setInitialized(LoadingStatus.LOADED);
    if (token) return;

    if (location.pathname.startsWith(routesConfig.activate)) return;
    if (location.pathname.startsWith(routesConfig.resetPassword)) return;

    navigate(routesConfig.auth);
  };

  React.useEffect(() => { initApp(); }, []);

  if (initialized === LoadingStatus.NEVER) {
    return <ArcGlobalLoading />;
  }
  
  return (
    <Routes>				
      <Route path='/auth/*' element={<AuthFeature />} />
      <Route path='/app/*' element={<AppFeature /> }/> 
      <Route path='*' element={ <Navigate to='/app' /> } />
    </Routes>
  );
};


export default Main;
